/**
 * @file
 * Sitewide javascript behaviors.
 */

/* global Foundation */

if (typeof drupalSettings === "undefined") {
  var drupalSettings = {};
}

(function ($, Drupal, drupalSettings, cookies, once) {
  "use strict";

  /**
   * Attach and detach Foundation JS.
   */
  Drupal.behaviors.foundation = {
    attach: function (context) {
      $(context)
        .foundation()
        .promise()
        .done(function () {
          document.querySelector("body").classList.add(ieVersion());
          setTimeout(function () {
            document
              .querySelector("html")
              .classList.add("foundation-processed");
            window.dispatchEvent(new Event("resize"));
          }, 1000);
        });

      function ieVersion() {
        var ua = window.navigator.userAgent;
        if (ua.indexOf("Trident/7.0") > -1) {
          return "ie11";
        }
      }
    },
  };

  Drupal.behaviors.readmore = {
    attach: function (context) {
      $(".session-body", context).readmore();
      var searchBarSubmit = document.querySelector(".search-bar-submit");
      if (searchBarSubmit) {
        searchBarSubmit.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            var $form = $(this).closest("form");
            $("input[data-bef-auto-submit-click]", $form).click();
          },
          false
        );
      }
    },
  };

  /**
   * Change the mobile menu icon on click.
   */
  Drupal.behaviors.mobileMenu = {
    attach: function (context) {
      document
        .querySelector(".bb_header--mobile__toggle")
        .addEventListener("click", function () {
          var mobileMenu = document.querySelector(".bb_header--mobile__menu");
          var hamburger = document.querySelector(
            ".bb_header--mobile__toggle i"
          );
          if (hamburger.classList.contains("fa-bars")) {
            hamburger.classList.remove("fa-bars");
            hamburger.classList.add("fa-xmark");
            mobileMenu.style.transform = "translateX(0)";
          } else {
            hamburger.classList.remove("fa-xmark");
            hamburger.classList.add("fa-bars");
            mobileMenu.style.transform = "translateX(-100%)";
          }
        });
    },
  };

  /**
   * Disable the top-level links in the main menu.
   */
  Drupal.behaviors.disableMenuLinks = {
    attach: function (context) {
      var disabledLink = document.querySelector(
        ".bb_header__link--disabled > a"
      );
      if (disabledLink) {
        disabledLink.addEventListener("click", function (e) {
          e.preventDefault();
        });
      }
    },
  };

  /**
   * Add end quotes.
   */
  Drupal.behaviors.quotes = {
    attach: function (context) {
      // $('.bb_node--quote--default__body p:last-child', context).append('"');
      // $('.bb_node--quote--teaser__inner__quote .quote-body p:last-child', context).append('"');
      document.querySelectorAll(
        ".bb_node--quote--default__body p:last-child"
      ).textContent += '"';
      document.querySelectorAll(
        ".bb_node--quote--teaser__inner__quote .quote-body p:last-child"
      ).textContent += '"';
    },
  };

  /**
   * Add a "main" element wrapper to Mannequin components only.
   */
  Drupal.behaviors.mannequin = {
    attach: function (context) {
      if (window.top != window.self) {
        var body = document.getElementsByTagName("body");
        if (
          body
            .querySelector("[class*='bb_component']")
            .classList.contains("paragraph")
        ) {
          body.innerHTML = "<main>" + body.innerHTML + "</main>";
        }
      }
    },
  };

  /**
   * Animations
   */
  Drupal.behaviors.animations = {
    attach: function (context) {
      if ("IntersectionObserver" in window) {
        if (window.matchMedia("(prefers-reduced-motion)").matches == false) {
          var callback = function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting === true) {
                entry.target.classList.add("in");
              }
            });
          };

          var observer = new IntersectionObserver(callback);

          var targets = document.querySelectorAll(".show-on-scroll img");
          targets.forEach(function (target) {
            observer.observe(target);
          });
        }
      } else {
        $(".show-on-scroll img").each(function () {
          $(this).addClass("in");
        });
      }
    },
  };

  /**
   * Keep the service menu Search input wider if it's populated.
   *
   * Display submit button when search input expands.
   */
  Drupal.behaviors.search = {
    attach: function (context) {
      var populatedClass = "bb_header__menu__search__input--has-search-term";
      var displaySubmitButtonClass = "display_search_submit_button";
      $(".bb_header__menu__search__input", context).blur(function () {
        if ($(this).val().length === 0) {
          $(this).removeClass(populatedClass);
          $(".bb_header__menu__search__submit").removeClass(
            displaySubmitButtonClass
          );
        } else {
          $(this).addClass(populatedClass);
        }
      });

      $(".bb_header__menu__search__input", context).focus(function () {
        $(".bb_header__menu__search__submit").addClass(
          displaySubmitButtonClass
        );
      });
    },
  };

  /**
   * Adjust heights for offset components.
   */
  Drupal.behaviors.offsets = {
    attach: function (context) {
      if (window.innerWidth >= 1024) {
        $(
          ".bb_component--header-background-image__text-box--offset-bottom"
        ).each(function () {
          var height = $(this).innerHeight();
          $(this)
            .closest(".bb_component--header-background-image")
            .next(
              "[class*='bb_component'], [class*='paragraph--type--listing']"
            )
            .css("padding-top", height / 3 + "px");
        });
      }

      $(".bb_component--cta-area--offset").each(function () {
        $(this)
          .closest(".bb_component--cta-area")
          .next("[class*='bb_component'], [class*='paragraph--type--listing']")
          .css("padding-top", 90 + "px");
      });
    },
  };

  /**
   * Position the 50-50 Content Block - Floating Headline component.
   */
  Drupal.behaviors.fiftyFiftyFloat = {
    attach: function (context) {
      $(".bb_component--fifty-fifty-content-block--float").each(function () {
        var introHeight = $(this)
          .find(".bb_component--fifty-fifty-content-block--float__intro")
          .innerHeight();
        $(this)
          .find(".bb_component__contents > .bb_component__main-content")
          .css("padding-top", introHeight / 2 + 30 + "px");
        $(this).css("margin-top", introHeight / -4 + "px");
      });
    },
  };

  /**
   * Add a parallax effect to the 50-50 Shape component.
   */
  Drupal.behaviors.parallax = {
    attach: function (context) {
      if ($("html").hasClass("js")) {
        if (window.matchMedia("(prefers-reduced-motion)").matches == false) {
          var scenes = [];
          var scenesSelector = document.querySelectorAll(
            ".bb_component--fifty-fifty-content-block--shape"
          );
          for (var i = 0; i < scenesSelector.length; i++) {
            if (
              !$(scenesSelector[i]).hasClass(
                "bb_component--fifty-fifty-content-block--shape--animation-disabled"
              )
            ) {
              scenes[i] = new Parallax(scenesSelector[i], {
                hoverOnly: true,
                relativeInput: true,
                frictionX: 0.05,
                frictionY: 0.05,
                selector: ".bb_component--fifty-fifty-content-block__shape",
              });
            }
          }
        }

        $(".bb_component--fifty-fifty-content-block--shape").each(function () {
          if ($(this).prev(".bb_component--fifty-fifty-content-block--shape")) {
            $(this)
              .prev(".bb_component--fifty-fifty-content-block--shape")
              .css("padding-bottom", "0");
          }
        });
      }
    },
  };

  /**
   * Stop autoplay for certain video elements if prefers-reduced-motion is true.
   */
  Drupal.behaviors.stopVideoAutoplay = {
    attach: function (context) {
      if ($("html").hasClass("js")) {
        if (window.matchMedia("(prefers-reduced-motion)").matches == false) {
          $(
            ".bb_component--fifty-fifty-content-block video, .bb_component--seventy-thirty-content-block video, .bb_component--image-headline__image video",
            context
          )
            .trigger("play")
            .attr("autoplay", "autoplay");
        }
      }
    },
  };

  /**
   * Allow click-to-pause/play for certain videos.
   */
  Drupal.behaviors.clickToPause = {
    attach: function (context) {
      $(".bb_component--seventy-thirty-content-block video", context).each(
        function () {
          $(this).on("click", function (e) {
            if ($(this).get(0).paused) {
              $(this).get(0).play();
            } else {
              $(this).get(0).pause();
            }
          });
        }
      );
    },
  };

  /**
   * Video - Header Underlay
   */
  Drupal.behaviors.videoUnderlay = {
    attach: function (context) {
      var $video = $(".bb_component--header--video video");

      // Don't play video for smaller screens or reduced-motion-preferrers.
      if (
        window.innerWidth >= 640 &&
        window.matchMedia("(prefers-reduced-motion)").matches == false
      ) {
        $("source", $video).each(function (index) {
          $(this).attr("src", $(this).data("src"));
          $video.get(index).load();
          // Supply fade-in to avoid FOUC.
          $(this)
            .closest(".bb_component--header--video__video-wrapper")
            .addClass("loaded");
        });
      } else {
        $video
          .closest(".bb_component--header--video__video-wrapper")
          .addClass("loaded loaded--poster");
      }

      // Add a custom pause/play button to the video.
      $(".bb_component--header--video__button-pause", context).click(function (
        e
      ) {
        var $v = $(this).closest(".bb_component--header--video").find("video");
        var $b = $(this).find("i");
        if ($v.get(0).paused) {
          $v.get(0).play();
          $b.removeClass("icon-play").addClass("icon-pause");
        } else {
          $v.get(0).pause();
          $b.removeClass("icon-pause").addClass("icon-play");
        }
      });
    },
  };

  /**
   * Reset Views filters.
   */
  Drupal.behaviors.resetFilters = {
    attach: function (context) {
      if (document.querySelector(".reset-button") !== null) {
        document
          .querySelector(".reset-button")
          .addEventListener("click", function (e) {
            e.preventDefault();

            var new_location =
              window.location.origin +
              window.location.pathname +
              "#form-filter";
            window.location.href = new_location;
          });
      }
      /*  $(".reset-button", context).click(function (e) {
        e.preventDefault();
        var $bbview = $(this).closest(".bb_view");
        var $selects = $bbview.find("select");
        var $text = $bbview.find('.form-text');

        $selects
          .each(function () {
            this.selectedIndex = 0;
          })
          .trigger("change");

        $text.val('');

        var new_location = window.location.origin + window.location.pathname + '#form-filter';
        window.location.href = new_location;
      }); */
    },
  };

  // A more plug and play approach to our reset link workaround, but requires
  // a submit button and is currently limited to partner catalog since that is
  // the only listing that works this way with the submit button currently.
  Drupal.behaviors.resetPartnerCatalog = {
    attach: function (context) {
      var $catalog = $(".view-partner-catalog", context);
      $('[data-drupal-selector="edit-reset"]', $catalog).click(function (e) {
        e.preventDefault();
        $("select", $catalog)
          .each(function () {
            this.selectedIndex = 0;
          })
          .trigger("change");
        $('input[type="text"]', $catalog).val("");

        $(
          '[data-drupal-selector="edit-submit-partner-catalog"]',
          $catalog
        ).click();
      });
    },
  };

  /**
   * Custom behaviors/setup for carousel.
   */
  Drupal.behaviors.carousel = {
    attach: function (context) {
      // Alter the tab behavior for the carousel.
      $(".orbit-bullets button", ".bb_component--quote-carousel").each(
        function () {
          $(this).on("keypress", function (e) {
            var keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode === "13") {
              var slide = $(this).attr("data-slide");
              var $focus = $(this)
                .closest(".orbit")
                .find(
                  ".orbit-container .orbit-slide[data-slide=" + slide + "]"
                );
              $focus.find("a").focus();
            }
          });
        }
      );

      // Put slide images into buttons and set the first one to active.
      $("div.bb_component--quote-carousel").each(function () {
        var $carousel = $(this);
        $carousel
          .find(".orbit-bullets button:first-of-type")
          .addClass("is-active");
        $carousel.find("li[data-slide]", ".orbit-container").each(function () {
          var image = $(this).find(
            ".bb_node--quote--carousel__affiliation_logo"
          );
          var slide = $(this).attr("data-slide");
          $carousel
            .find(".orbit-bullets button[data-slide=" + slide + "]")
            .append(image);
        });
      });

      // Set the carousel height for taller slides.
      $("[data-orbit]").on("beforeslidechange.zf.orbit", function () {
        $(this).attr(
          "data-last-slide-height",
          $(".orbit-slide.is-in").height()
        );
      });

      $("[data-orbit]").on("slidechange.zf.orbit", function () {
        var newHeight = $(".orbit-slide.is-in").height();
        var oldHeight = $("[data-orbit]").attr("data-last-slide-height")
          ? $("[data-orbit]").attr("data-last-slide-height")
          : $(".orbit-container").height();
        if (oldHeight < newHeight) {
          $(".orbit-container").css("height", newHeight);
        }
      });
    },
  };

  Drupal.behaviors.accordionMenu = {
    attach: function (context) {
      $("ul.menu.accordion-menu ul", context).each(function () {
        if (
          $(this).closest(".bb_header--mobile").length === 1 &&
          $(this).hasClass("menu-level-2")
        ) {
          // If it's the main menu, only touch level 1.
          return;
        }
        // Check a data-no-home-link attribute for menus where this
        // doesn't make sense
        if ($(this).data("no-home-link")) {
          return;
        }
        var parent = $(this).parent();
        $(this).prepend(
          "<li><a href='" +
            parent.find("a:first").attr("href") +
            "'>" +
            parent.find("a:first").html() +
            " " +
            Drupal.t("Home") +
            "</a></li>"
        );
      });
    },
  };

  /* Drupal.behaviors.regionSelect = {
    attach: function (context) {
      var settings = drupalSettings.bb_group;
      var defaultRegion = cookies.get("default-region");
      var $changeRegionModal = $("#change-region-modal", context);

      if ($changeRegionModal.length === 0) {
        return;
      }

      var $locationSelector = new Foundation.Reveal($changeRegionModal);
      var currentCountryCode = settings.current_country;
      var visitingFromCountry = undefined;

      Object.keys(settings.region_map).some(function (element) {
        if (settings.region_map[element].includes(currentCountryCode)) {
          visitingFromCountry = element;
          return true;
        }
      });

      // debug.
      // var $debug = $('<div>' +
      //   '<p>currently viewing: group ' + settings.current_group.label + ' (' + settings.current_group.id + ') </p>' +
      //   '<p>visiting from country: ' + currentCountryCode + ' (' + visitingFromCountry + ')</p>' +
      //   '<p>default group: ' + defaultRegion + '</p>' +
      //   '</div>').css({position: 'fixed', bottom: 0, backgroundColor: 'red'});
      // $('body').append($debug);

      // If there is no lookup for the current country,
      // and the user does not have a default region set,
      // and they are not viewing north america.
      if (
        typeof visitingFromCountry === "undefined" &&
        !defaultRegion &&
        settings.current_group.id != 6
      ) {
        // Set the default group to north america.
        cookies.set("default-region", 6);
        window.location.href = "/";
      }
      // If there is a lookup for the country the user is visiting
      // from and it is different from the group they are currently viewing
      // and they do not have a default region.
      else if (
        String(visitingFromCountry) !== String(settings.current_group.id) &&
        !defaultRegion
      ) {
        $locationSelector.open();
        $("#modal-closer-change-region", context).click(function (e) {
          e.preventDefault();
          cookies.set("default-region", settings.current_group.id);
          $locationSelector.close();
        });
      }
      // If the user is visiting from a country that is different than the current group,
      // and has a default region that is different from the current region.
      else if (
        (String(visitingFromCountry) !== String(settings.current_group.id) &&
          String(defaultRegion) !== String(settings.current_group.id)) ||
        (String(visitingFromCountry) === String(settings.current_group.id) &&
          defaultRegion &&
          String(defaultRegion) !== String(settings.current_group.id))
      ) {
        var $defaultSelector = new Foundation.Reveal(
          $("#change-default-modal", context)
        );
        $defaultSelector.open();
        $("#modal-closer-default-region", context).click(function (e) {
          e.preventDefault();
          cookies.set("default-region", settings.current_group.id);
          $defaultSelector.close();
        });
        $(".modal-closer-default-cancel", context).click(function (e) {
          e.preventDefault();
          $defaultSelector.close();
        });
      }
    },
  }; */

  Drupal.behaviors.cookiesDirective = {
    attach: function (context) {
      var $cookiesDirective = $("#cookie-disclosure", context);
      if (typeof cookies.get("cookiesDirective") === "undefined") {
        $cookiesDirective.addClass("show-notice");
      }

      $("#cookie-compliance-control", context).click(function () {
        $cookiesDirective.removeClass("show-notice");
        cookies.set("cookiesDirective", true);
      });
    },
  };

  Drupal.behaviors.captcha = {
    attach: function (context) {
      $(".paragraph--type--form .js-form-submit").on("click", function (e) {
        if (grecaptcha && grecaptcha.getResponse().length === 0) {
          e.preventDefault();
          $(".bb_captcha-error").fadeIn();
        }
      });
    },
  };

  Drupal.behaviors.iframe = {
    attach: function (context) {
      $(once("iframe", "iframe.fullsize")).each(function () {
        if (typeof $.fn.iFrameResize !== "undefined") {
          $("iframe").iFrameResize({});
        }
      }, 1000);
    },
  };

  Drupal.behaviors.benefitsCarousel = {
    attach: function (context) {
      $(document).ready(function () {
        var $carousels = $(".bb_component--benefits-carousel");

        function sliderInit($carousel) {
          var $sliderContent = $carousel.find(
            ".bb_component--benefits-carousel__slider--content"
          );
          var $sliderImages = $carousel.find(
            ".bb_component--benefits-carousel__slider--images"
          );
          var slideCount = $sliderContent
            .find(".bb_component--benefits-carousel__slider__slide")
            .toArray().length;

          $sliderContent.slick({
            arrows: false,
            asNavFor: $sliderImages,
            autoplay: true,
            autoplaySpeed: 20000,
            cssEase: "linear",
            draggable: false,
            infinite: true,
            focusOnSelect: true,
            responsive: [{ breakpoint: 970, settings: "unslick" }],
            slidesToShow: slideCount,
            swipe: false,
            vertical: true,
            waitForAnimate: false,
          });
          $sliderImages.slick({
            arrows: false,
            fade: true,
            lazyLoad: "ondemand",
            draggable: false,
            swipe: false,
          });
        }

        $carousels.each(function () {
          sliderInit($(this));
        });

        $(window).on("resize", function () {
          $carousels.each(function () {
            sliderInit($(this));
          });
        });

        $(".bb_component--benefits-carousel__slider--content").on(
          "afterChange",
          function (event, slick, currentSlide, nextSlide) {
            $(this)
              .find(".slick-slide")
              .each(function () {
                if ($(this).attr("data-slick-index") < currentSlide) {
                  $(this).addClass("past-slide");
                } else {
                  $(this).removeClass("past-slide");
                }
              });
          }
        );
        if (typeof $sliderContent !== "undefined") {
          $sliderContent.on("click", function () {
            $sliderContent.slick("slickPause");
          });
        }
      });
    },
  };

  Drupal.behaviors.partnerCarousel = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(
          ".bb_component--featured-partner-carousel .bb_component__main-content"
        );

        $slider.slick({
          adaptiveHeight: false,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 10000,
          dots: true,
          focusOnSelect: true,
          slidesToShow: 1,
        });
      });
    },
  };

  Drupal.behaviors.homePageCarousel = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(
          ".bb_component--home-page-carousel .bb_component__main-content"
        );

        $slider.slick({
          adaptiveHeight: false,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 10000,
          dots: true,
          focusOnSelect: true,
          slidesToShow: 1,
        });
      });
    },
  };

  Drupal.behaviors.FutureOfEdTech = {
    attach: function (context) {
      var $slider = $(
        ".bb_custom_component--edtech-history-widget .icons-slider"
      );
      var $sliderTexts = $(
        ".bb_custom_component--edtech-history-widget .timeline-texts"
      );
      $slider.slick({
        arrows: true,
        autoplaySpeed: 10000,
        focusOnSelect: true,
        slidesToShow: 5,
        infinite: true,
        centerMode: true,
        centerPadding: "10px",
        asNavFor: ".bb_custom_component--edtech-history-widget .timeline-texts",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 460,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      $sliderTexts.slick({
        arrows: false,
        autoplaySpeed: 10000,
        focusOnSelect: true,
        slidesToShow: 1,
        infinite: true,
        fade: true,
        cssEase: "linear",
        asNavFor: ".bb_custom_component--edtech-history-widget .icons-slider",
      });

      var $studentQuoteCarousel = $("#student-quote-carousel");
      $studentQuoteCarousel.slick({
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        focusOnSelect: true,
        slidesToShow: 1,
        infinite: true,
        cssEase: "linear",
        vertical: true,
        adaptiveHeight: true,
        useTransform: true,
      });
    },
  };

  Drupal.behaviors.formSubmitGTM = {
    attach: function (context) {
      window.addEventListener(
        "message",
        function (e) {
          var key = e.message ? "message" : "data";
          var data = e[key];

          if (typeof data === "string" && !data.includes("form_submission")) {
            return;
          }

          if (e.origin !== "https://go.blackboard.com") {
            return;
          }

          dataLayer.push({ event: "gtm.formSubmit" });
        },
        false
      );
    },
  };

  /**
   * Acquia strips out utm query parameters from the request, this adds them back to the Eloqua iframe.
   */
  Drupal.behaviors.eloquaFormUtmParams = {
    attach: function (context) {
      var $iframe = $(".paragraph--type--eloquaform iframe", context);

      if ($iframe.length === 0) {
        return;
      }

      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var utmParams = [
        "utm_source",
        "utm_medium",
        "utm_term",
        "utm_content",
        "utm_campaign",
        "cid",
      ];

      $.each(utmParams, function (index, utm_name) {
        if (urlParams.has(utm_name)) {
          var iframeUrl = $iframe.attr("src");
          var utm_value = urlParams.get(utm_name);
          $iframe.attr("src", iframeUrl + "&" + utm_name + "=" + utm_value);
        }
      });
    },
  };

  /**
   * Listen for the Eloqua iframe confirmation page postMessage and redirect to the value set in the EloquaForm paragraph field.
   *
   * This is what comes from Eloqua: window.parent.postMessage('confirmation_page', '*');
   */
  Drupal.behaviors.confirmationPage = {
    attach: function (context) {
      window.addEventListener(
        "message",
        function (e) {
          var key = e.message ? "message" : "data";
          var data = e[key];

          if (typeof data === "string" && !data.includes("confirmation_page")) {
            return;
          }

          if (e.origin !== "https://go.blackboard.com") {
            return;
          }

          if (typeof drupalSettings.bb_group !== "undefined") {
            if (
              typeof drupalSettings.bb_group.eloquaform_paragraph_redirect ===
              "string"
            ) {
              window.location.href =
                drupalSettings.bb_group.eloquaform_paragraph_redirect;
            }
          }
        },
        false
      );
    },
  };

  Drupal.behaviors.eloquaBrandStyles = {
    attach: function (context) {
      if (typeof drupalSettings.bb_group !== "undefined") {
        if (typeof drupalSettings.bb_group.eloqua_styles === "string") {
          var eloqua_styles = drupalSettings.bb_group.eloqua_styles;
          var iframe_elements = document.getElementsByTagName("iframe");
          for (var i = 0, max = iframe_elements.length; i < max; i++) {
            var iframe = iframe_elements[i];
            var src = iframe.src;
            if (src.includes("go.blackboard.com")) {
              if ($(iframe).parents(".bb_theme--palette-brand").length) {
                $(iframe).on("load", function () {
                  var iframe_window = this.contentWindow;
                  iframe_window.postMessage(
                    ["add_brand_styling", eloqua_styles],
                    "https://go.blackboard.com"
                  );
                });
              }
            }
          }
        }
      }
    },
  };

  /**
   * Set Aria expanded to true/false for menus.
   */
  Drupal.behaviors.menuAriaExpanded = {
    attach: function (context) {
      setAriaState();

      $(document).on("show.zf.dropdownmenu hide.zf.dropdownmenu", function () {
        setAriaState();
      });

      function setAriaState() {
        $("li.is-dropdown-submenu-parent", context).each(function () {
          if ($(this).hasClass("is-active")) {
            $(this).attr("aria-expanded", "true");
          } else {
            $(this).attr("aria-expanded", "false");
          }
        });
      }
    },
  };

  /**
   * Check for URL variables and add them to internal links
   */
  Drupal.behaviors.urlVariables = {
    attach: function (context) {
      if (context.querySelector("body") !== null) {
        if (!context.querySelector("body").classList.contains("uv-once")) {
          context.querySelector("body").classList.add("uv-once");

          var url_variables = [];
          var url_variables_formatted = "";

          var cid = getQueryVariable(window.location.href, "cid");
          if (cid !== false) {
            url_variables.push("cid=" + cid);
          }

          var utm_campaign = getQueryVariable(
            window.location.href,
            "utm_campaign"
          );
          if (utm_campaign !== false) {
            url_variables.push("utm_campaign=" + utm_campaign);
          }

          var utm_source = getQueryVariable(window.location.href, "utm_source");
          if (utm_source !== false) {
            url_variables.push("utm_source=" + utm_source);
          }

          var utm_medium = getQueryVariable(window.location.href, "utm_medium");
          if (utm_medium !== false) {
            url_variables.push("utm_medium=" + utm_medium);
          }

          var utm_term = getQueryVariable(window.location.href, "utm_term");
          if (utm_term !== false) {
            url_variables.push("utm_term=" + utm_term);
          }

          var utm_content = getQueryVariable(
            window.location.href,
            "utm_content"
          );
          if (utm_content !== false) {
            url_variables.push("utm_content=" + utm_content);
          }

          if (url_variables.length > 0) {
            url_variables_formatted = url_variables.join("&");
          }

          context.body.querySelectorAll("a").forEach(function (el) {
            if (
              (el.href.indexOf("/try") !== -1 ||
                el.href.indexOf("go.blackboard.com") !== -1) &&
              el.href.indexOf("/admin") === -1 &&
              el.href.indexOf("/node") === -1 &&
              el.href.indexOf("/user") === -1
            ) {
              if (url_variables_formatted !== "") {
                if (el.href.indexOf("?") !== -1) {
                  el.href = el.href + "&" + url_variables_formatted;
                } else {
                  el.href = el.href + "?" + url_variables_formatted;
                }
              }
            }
          });
        }
      }

      function getQueryVariable(query, variable) {
        if (query.indexOf("?") !== -1) {
          query = query.substring(query.indexOf("?") + 1, query.length);
        }
        if (query.indexOf("#") !== -1) {
          query = query.substring(0, query.indexOf("#"));
        }
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] === variable) {
            return pair[1];
          }
        }
        return false;
      }
    },
  };

  /**
   * Modal reveal for the partner directory page
   */
  Drupal.behaviors.partnerReveal = {
    attach: function (context) {
      if (
        document
          .querySelector("body")
          .classList.contains("page-partner-directory") ||
        document
          .querySelector("body")
          .classList.contains("page-integration-partnerships") ||
        document
          .querySelector("body")
          .classList.contains("page-parcerias-de-integração") ||
        document
          .querySelector("body")
          .classList.contains("page-socios-de-integración")
      ) {
        document
          .querySelectorAll(".bb_node--integration-partner--teaser__link")
          .forEach(function (el) {
            el.addEventListener("click", function (e) {
              e.preventDefault();
              var parentElement = document.querySelector(
                "#" + el.getAttribute("data-reveal-id")
              ).parentNode;
              parentElement.style.display = "block";
              parentElement.querySelector(".reveal-modal").focus();

              document.addEventListener("keydown", function (e) {
                if (e.key === "Escape") {
                  var parentElementId = parentElement
                    .querySelector(".reveal-modal")
                    .getAttribute("id");
                  parentElement.style.display = "none";
                  document
                    .querySelector('[data-reveal-id="' + parentElementId + '"]')
                    .focus();
                }
              });

              parentElement
                .querySelector(".close-reveal-modal")
                .addEventListener("click", function (e) {
                  e.preventDefault();
                  var parentElementId = parentElement
                    .querySelector(".reveal-modal")
                    .getAttribute("id");
                  parentElement.style.display = "none";
                  document
                    .querySelector('[data-reveal-id="' + parentElementId + '"]')
                    .focus();
                });
            });
          });
      }

      if (
        document
          .querySelector("body")
          .classList.contains("page-integration-partnerships")
      ) {
        var view_link = document.createElement("a");
        view_link.classList.add("bb_cta--hollow", "bb_cta--text");
        view_link.href = "/integration-partnerships/partner-directory";
        view_link.innerText = "View Full Partner Directory";

        document
          .querySelector(
            ".paragraph--type--integration-partnerships-teaser > div:first-child"
          )
          .appendChild(view_link);
      }
    },
  };

  /**
   * Products Menu
   */
  Drupal.behaviors.productsMenu = {
    attach: function (context) {
      var productMenuTabs = document.querySelector(".product-menu-tabs a");
      if (productMenuTabs !== null) {
        var productMenuAnchors = document.querySelectorAll(
          ".product-menu-tabs a"
        );
        Array.prototype.forEach.call(productMenuAnchors, function (el) {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            var selected = el;
            var industry = selected.getAttribute("data-industry");

            var activeTab = document.querySelector(
              ".product-menu-tabs .is-active"
            );
            if (activeTab !== null) {
              activeTab.classList.remove("is-active");
            }

            setTimeout(function () {
              selected.classList.add("is-active");
            }, 100);

            var productMenuContent = document.querySelectorAll(
              ".product-menu-content"
            );
            Array.prototype.forEach.call(
              productMenuContent,
              function (element) {
                // Skip elements that are descendants of a services-menu-container
                var closestServiceMenu = element.closest(
                  ".services-menu-container"
                );
                if (closestServiceMenu) {
                  return;
                }

                if (element.getAttribute("data-industry") === industry) {
                  element.classList.remove("display-none");
                } else {
                  element.classList.add("display-none");
                }
              }
            );
          });
        });
      }
    },
  };

  /**
   * Featured Items
   */
  Drupal.behaviors.featuredItems = {
    attach: function (context) {
      if (document.querySelector(".featured-resource-container") !== null) {
        document
          .querySelectorAll(".featured-resource-container .display-none")
          .forEach(function (el) {
            el.classList.remove("display-none");
          });
      }
    },
  };

  /**
   * Contact Drop Down
   */
  Drupal.behaviors.contactMethod = {
    attach: function (context) {
      if (document.querySelector(".contact-options") !== null) {
        document
          .querySelector(".contact-options")
          .addEventListener("click", function (e) {
            e.preventDefault();
            var contactMenu = e.target;

            contactMenu
              .closest(".contact-dropdown-container")
              .querySelector("ul").style.height = contactMenu
              .closest(".contact-dropdown-container")
              .querySelector("ul")
              .classList.contains("dropdown-open")
              ? "0px"
              : contactMenu
                  .closest(".contact-dropdown-container")
                  .querySelector("ul").scrollHeight + "px";
            contactMenu
              .closest(".contact-dropdown-container")
              .querySelector("ul")
              .classList.toggle("dropdown-open");
          });
      }
    },
  };

  /**
   * File Downloads
   */
  Drupal.behaviors.fileDownloads = {
    attach: function (context) {
      if (document.querySelector(".file-download") !== null) {
        var type = document
          .querySelector(".file-download")
          .getAttribute("data-type");

        var category = document
          .querySelector(".file-download")
          .getAttribute("data-category");

        if (type == "paper") {
          document.querySelector(".file a").innerText =
            "Download the " + category;
        } else if (type == "brochure") {
          document.querySelector(".file a").innerText =
            "Download the " + category;
        }

        document.querySelector(".file a").classList.add("x-gradient-button");
        document
          .querySelector(".file")
          .nextElementSibling.parentNode.removeChild(
            document.querySelector(".file").nextElementSibling
          );

        //   document.addEventListener('click', function (event) {
        //     if (!event.target.matches('.file a')){
        //       return;
        //     }
        //     event.preventDefault();
        //     // https://api.jqueryui.com/dialog/
        //     $("#gated_content").dialog({
        //       modal: true,
        //       resizable: false,
        //       title: "Gated Content",
        //       height: 400,
        //       width: 600
        //     });
        //   }, false);
      }
    },
  };

  /**
   * Modal reveal for the leadership page
   */
  Drupal.behaviors.leadershipReveal = {
    attach: function (context) {
      if (
        document.querySelector("body").classList.contains("page-leadership") ||
        document.querySelector("body").classList.contains("page-liderança") ||
        document.querySelector("body").classList.contains("page-liderazgo")
      ) {
        document.querySelectorAll(".card-toggle").forEach(function (el) {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            var parentElement = document.querySelector(
              "#" + el.getAttribute("data-bio")
            ).parentNode;
            parentElement.style.display = "block";
            parentElement.querySelector(".reveal-modal").focus();

            document.addEventListener("keydown", function (e) {
              if (e.key === "Escape") {
                var parentElementId = parentElement
                  .querySelector(".reveal-modal")
                  .getAttribute("id");
                parentElement.style.display = "none";
                document
                  .querySelector('[data-bio="' + parentElementId + '"]')
                  .focus();
              }
            });

            parentElement
              .querySelector(".close-reveal-modal")
              .addEventListener("click", function (e) {
                e.preventDefault();
                var parentElementId = parentElement
                  .querySelector(".reveal-modal")
                  .getAttribute("id");
                parentElement.style.display = "none";
                document
                  .querySelector('[data-bio="' + parentElementId + '"]')
                  .focus();
              });
          });
        });
      }
    },
  };

  /**
   * Support Drop Down
   */
  Drupal.behaviors.supportOptions = {
    attach: function (context) {
      if (
        document.querySelector(".product-support-container .bb_cta--hollow") !==
        null
      ) {
        document
          .querySelector(".product-support-container .bb_cta--hollow")
          .addEventListener("click", function (e) {
            e.preventDefault();
            var supportMenu = e.target;

            supportMenu.parentNode.querySelector(
              ".product-support-options"
            ).style.height = supportMenu.parentNode
              .querySelector(".product-support-options")
              .classList.contains("dropdown-open")
              ? "0px"
              : supportMenu.parentNode.querySelector(".product-support-options")
                  .scrollHeight +
                40 +
                "px";
            supportMenu.parentNode
              .querySelector(".product-support-options")
              .classList.toggle("dropdown-open");
          });
      }
    },
  };

  /**
   * Filter Drop Downs
   */
  Drupal.behaviors.filterDropDowns = {
    attach: function (context) {
      if (
        document.querySelector(".views-exposed-form.bef-exposed-form") !== null
      ) {
        var hiddenElement = document.createElement("span");
        hiddenElement.classList.add("hidden-element");
        document.querySelector("body").appendChild(hiddenElement);

        document
          .querySelectorAll(".views-exposed-form.bef-exposed-form select")
          .forEach(function (el) {
            var selectedText = el.options[el.selectedIndex].text;
            hiddenElement.innerText = selectedText;
            el.style.width = hiddenElement.scrollWidth + 60 + "px";
          });

        $(once("weberAjaxViews", document)).ajaxSuccess(function (
          event,
          xhr,
          settings
        ) {
          if (
            drupalSettings &&
            drupalSettings.views &&
            drupalSettings.views.ajaxViews
          ) {
            var ajaxViews = drupalSettings.views.ajaxViews;
            var viewList = [
              "webinars",
              "blogs",
              "research_white_papers",
              "brochures_materials",
              "featured_articles",
              "integration_partners",
              "industry_conferences",
            ];
            Object.keys(ajaxViews || {}).forEach(function (i) {
              if (
                viewList.indexOf(ajaxViews[i]["view_name"]) != -1 &&
                ajaxViews[i]["view_display_id"] == "block_1"
              ) {
                document
                  .querySelectorAll(
                    ".views-exposed-form.bef-exposed-form select"
                  )
                  .forEach(function (el) {
                    if (el.selectedIndex != 0) {
                      el.classList.add("current-filter");
                    } else {
                      el.classList.remove("current-filter");
                    }

                    var selectedText = el.options[el.selectedIndex].text;
                    hiddenElement.innerText = selectedText;
                    el.style.width = hiddenElement.scrollWidth + 60 + "px";
                  });
              }
            });
          }
        });
      }
    },
  };

  /**
   * iX eBook Slider
   */
  Drupal.behaviors.iXeBookSlider = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".ix-slider");

        $slider.slick({
          adaptiveHeight: true,
          arrows: true,
          infinite: true,
          speed: 750,
          dots: true,
          focusOnSelect: true,
          slidesToShow: 1,
          centerMode: true,
          customPaging: function (slider, i) {
            var date = "";
            switch (i) {
              case 0:
                date = "1820's";
                break;
              case 1:
                date = "1910's";
                break;
              case 2:
                date = "1960's";
                break;
              case 3:
                date = "1970's ";
                break;
              case 4:
                date = "1980's";
                break;
              case 5:
                date = "1990's";
                break;
              case 6:
                date = "2000's";
                break;
              case 7:
                date = "2010's";
                break;
              case 8:
                date = "2020's";
                break;
              default:
                date = "Date";
                break;
            }
            return $('<button type="button" />').text(date);
          },
          appendArrows: $(".ix-nav"),
          appendDots: $(".ix-nav"),
        });
      });
    },
  };

  /**
   * Student Quote Slider on iX page
   */
  Drupal.behaviors.iXeQuoteSlider = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".ix-quote-slider");

        $slider.slick({
          adaptiveHeight: false,
          arrows: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          focusOnSelect: true,
          slidesToShow: 1,
          prevArrow: $(".ix-quote-prev"),
          nextArrow: $(".ix-quote-next"),
          appendDots: $(".ix-quote-dots"),
        });
      });
    },
  };

  /* Fade in content on scroll */

  Drupal.behaviors.fadeUpIn = {
    attach: function (context) {
      var scrollElements = document.querySelectorAll(".js-scroll");
      var elementInView = function elementInView(el) {
        var dividend =
          arguments.length <= 1 || arguments[1] === undefined
            ? 1
            : arguments[1];
        var elementTop = el.getBoundingClientRect().top;
        return (
          elementTop <=
          (window.innerHeight || document.documentElement.clientHeight) /
            dividend
        );
      };
      var elementOutofView = function elementOutofView(el) {
        var elementTop = el.getBoundingClientRect().top;
        return (
          elementTop >
          (window.innerHeight || document.documentElement.clientHeight)
        );
      };
      var displayScrollElement = function displayScrollElement(element) {
        element.classList.add("scrolled");
      };
      var hideScrollElement = function hideScrollElement(element) {
        element.classList.remove("scrolled");
      };
      var handleScrollAnimation = function handleScrollAnimation() {
        scrollElements.forEach(function (el) {
          if (elementInView(el, 1.25)) {
            displayScrollElement(el);
          } else if (elementOutofView(el)) {
            hideScrollElement(el);
          }
        });
      };
      window.addEventListener("scroll", function () {
        handleScrollAnimation();
      });
    },
  };

  /* Pathfactory iframe URL passing */

  Drupal.behaviors.pathfactoryIframe = {
    attach: function (context) {
      window.requestAnimationFrame(function iframePost() {
        const iframe = document.querySelector("[src*='LP=']");
        if (!iframe) {
          window.requestAnimationFrame(iframePost);
          return;
        }
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc.readyState != "complete") {
          window.requestAnimationFrame(iframePost);
          return;
        }
        setTimeout(function () {
          const message = JSON.stringify({
            sourceUrl: window.location.href,
            date: Date.now(),
          });
          iframe.contentWindow.postMessage(message, "*");
        }, 2000);
      });
    },
  };

  /* Product Page Video Button */

  Drupal.behaviors.productVideoButton = {
    attach: function (context) {
      if (document.querySelector(".bb_cta--video") !== null) {
        if (
          document.querySelector(".reveal-overlay").querySelector("iframe") !==
          null
        ) {
          var iframe = document
            .querySelector(".reveal-overlay")
            .querySelector("iframe");
          var player = new Vimeo.Player(iframe);
        }

        document.querySelectorAll(".bb_cta--video").forEach(function (el) {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector(".reveal-overlay").style.display = "block";
            document.querySelector(".reveal-modal").focus();

            if (
              document
                .querySelector(".reveal-overlay")
                .querySelector("iframe") !== null
            ) {
              if (e.isTrusted === true) player.play();
            }

            document.addEventListener("keydown", function (e) {
              if (e.key === "Escape") {
                document.querySelector(".reveal-overlay").style.display =
                  "none";
                document.querySelector(".bb_cta--video").focus();

                if (
                  document
                    .querySelector(".reveal-overlay")
                    .querySelector("iframe") !== null
                ) {
                  if (e.isTrusted === true) player.pause();
                }
              }
            });

            document
              .querySelector(".close-reveal-modal")
              .addEventListener("click", function (e) {
                e.preventDefault();
                document.querySelector(".reveal-overlay").style.display =
                  "none";
                document.querySelector(".bb_cta--video").focus();

                if (
                  document
                    .querySelector(".reveal-overlay")
                    .querySelector("iframe") !== null
                ) {
                  if (e.isTrusted === true) player.pause();
                }
              });
          });
        });
      }
    },
  };

  /* Accordion Toggle */

  Drupal.behaviors.accordionToggle = {
    attach: function (context) {
      if (document.querySelector(".accordion-toggle") !== null) {
        // Dummy check to make sure the clickable element, usually a button tag, exists on the page
        [].forEach.call(
          document.querySelectorAll(".accordion-toggle"),
          function (el) {
            // Go through each clickable element
            el.addEventListener("click", function (e) {
              // Add the click event listener
              e.preventDefault(); // Prevent the default click behavior
              e.target.classList.toggle("accordion-open"); // Toggle the class identifying if it is open or not
              setTimeout(function () {
                // Short timeout just to avoid any jittery behavior
                var accordion = e.target.getAttribute("data-controls"); // Gets the data-controls element from the button which is used to target the container div down below
                var expanded = e.target.classList.contains("accordion-open")
                  ? "true"
                  : "false"; // Set whether or not the current accordion is expanded
                e.target.setAttribute("aria-expanded", expanded); // Set the aria attribute for accessibility
                document.querySelector(
                  'div[data-accordion="' + accordion + '"]'
                ).style.height =
                  expanded === "true"
                    ? document.querySelector(
                        'div[data-accordion="' + accordion + '"]'
                      ).scrollHeight +
                      10 +
                      "px"
                    : "0"; // If not expanded set the height of the expandable element #mainNav to the scrollHeight of the element + a little extra, else set it to 0
                document.querySelector(
                  'div[data-accordion="' + accordion + '"]'
                ).style.paddingTop = expanded === "true" ? "10px" : "0"; // If necessary, set some padding on the top to give it breathing room, not specifically necessary, but can be useful
              }, 50);
            });
          }
        );
      }
    },
  };

  /* Decorate URLs with UTM parameters */

  Drupal.behaviors.decorateURLs = {
    attach: function (context) {
      var domainsToDecorate = [
          //add or remove domains (without https or trailing slash)
          "www.anthology.com/contact-us/sales",
          "www.anthology.com/en-emea/contact-us/sales",
          "www.anthology.com/en-apac/contact-us/sales",
          "www.anthology.com/en-in/contact-us/sales",
          "www.anthology.com/es-lac/comuniquese-con-nosotros",
          "www.anthology.com/pt-br/fale-conosco/vendas",
          "www.anthology.com/es-es/pongase-en-contacto-con-nosotros/ventas",
          "www.anthology.com/try",
          "www.anthology.com/ai-design-assistant/contact-us",
          "www.anthology.com/blackboard-ultra/contact-us",
          "www2.anthology.com",
          "careers.anthology.com",
          "community.anthology.com",
          "forms.anthology.com",
          "learn.anthology.com",
          "learn-toolkit.anthology.com",
          "shop.blackboard.com",
          "appcatalog.anthology.com",
          "newthology.lndo.site/contact-us/sales",
          "newthology.lndo.site/en-emea/contact-us/sales",
          "newthology.lndo.site/en-apac/contact-us/sales",
          "newthology.lndo.site/en-in/contact-us/sales",
          "newthology.lndo.site/es-lac/comuniquese-con-nosotros",
          "newthology.lndo.site/pt-br/fale-conosco/vendas",
          "newthology.lndo.site/es-es/pongase-en-contacto-con-nosotros/ventas",
          "newthology.lndo.site/try",
          "newthology.lndo.site/ai-design-assistant/contact-us",
          "newthology.lndo.site/blackboard-ultra/contact-us",
        ],
        queryParams = [
          "utm_medium", //add or remove query parameters you want to transfer
          "utm_source",
          "utm_campaign",
          "utm_term",
          "utm_content",
          "cid",
        ];

      setParameterCookie("utm_campaign", "anth_utm_campaign");
      setParameterCookie("utm_source", "anth_utm_source");
      setParameterCookie("utm_medium", "anth_utm_medium");
      setParameterCookie("utm_term", "anth_utm_term");
      setParameterCookie("utm_content", "anth_utm_content");
      setParameterCookie("cid", "anth_cid");

      // do not edit anything below this line
      var links = document.querySelectorAll("a");

      // check if links contain domain from the domainsToDecorate array and then decorates
      for (var linkIndex = 0; linkIndex < links.length; linkIndex++) {
        for (
          var domainIndex = 0;
          domainIndex < domainsToDecorate.length;
          domainIndex++
        ) {
          if (
            links[linkIndex].href.indexOf(domainsToDecorate[domainIndex]) >
              -1 &&
            links[linkIndex].href.indexOf("#") === -1
          ) {
            links[linkIndex].href = decorateUrl(links[linkIndex].href);
          }
        }
      }
      // decorates the URL with query params
      function decorateUrl(urlToDecorate) {
        var decorateStarter = urlToDecorate.indexOf("?") === -1 ? "?" : "&";
        var collectedQueryParams = [];
        for (
          var queryIndex = 0;
          queryIndex < queryParams.length;
          queryIndex++
        ) {
          var cookieName = "anth_" + queryParams[queryIndex];
          if (
            getQueryParam(queryParams[queryIndex]) ||
            Cookies.get(cookieName)
          ) {
            var queryParamValue =
              getQueryParam(queryParams[queryIndex]) !== undefined
                ? getQueryParam(queryParams[queryIndex])
                : Cookies.get(cookieName) !== undefined
                ? Cookies.get(cookieName)
                : "";
            collectedQueryParams.push(
              queryParams[queryIndex] + "=" + queryParamValue
            );
          }
        }
        return collectedQueryParams.length > 0
          ? urlToDecorate + decorateStarter + collectedQueryParams.join("&")
          : urlToDecorate;
      }

      // borrowed from https://stackoverflow.com/questions/831030/
      // a function that retrieves the value of a query parameter
      function getQueryParam(name) {
        if (
          (name = new RegExp(
            "[?&]" + encodeURIComponent(name) + "=([^&]*)"
          ).exec(window.location.search))
        )
          return decodeURIComponent(name[1]);
      }

      function setParameterCookie(queryParam, cookieName) {
        var urlParameterCheck = getQueryParam(queryParam);
        var urlParameterCookieCheck = Cookies.get(cookieName);

        // if the cookie is not set
        if (urlParameterCookieCheck === undefined) {
          // if the URL parameter is set
          if (urlParameterCheck !== undefined) {
            // set the parameter cookie
            Cookies.set(cookieName, urlParameterCheck, {
              domain: window.location.host,
              secure: true,
            });
          }
        }
        // if the cookie is set
        else {
          // if the URL parameter is set but not equal to the cookie value
          if (
            urlParameterCheck !== undefined &&
            urlParameterCheck !== urlParameterCookieCheck
          ) {
            // remove the old cookie
            Cookies.remove(cookieName);
            // set the new cookie
            Cookies.set(cookieName, urlParameterCheck, {
              domain: window.location.host,
              secure: true,
            });
          }
        }
      }
    },
  };

  /* About Page Typewriter */

  Drupal.behaviors.typewriterEffect = {
    attach: function (context) {
      // array with texts to type in typewriter
      var dataText = {
        en: [
          "walking in your shoes",
          "helping you connect the dots",
          "building visionary tools",
          "everything.",
        ],
        es: [
          "ponerse en su lugar",
          "ayudarlo a atar cabos",
          "crear herramientas innovadoras",
          "todo.",
        ],
        "es-sp": [
          "ponerse en su lugar",
          "ayudarle a atar cabos",
          "crear herramientas innovadoras",
          "todo.",
        ],
        pt: [
          "andar com os próprios pés",
          "ajudar você a conectar os pontos",
          "construir ferramentas inovadoras",
          "tudo.",
        ],
        ar: [
          "هو أن نضع أنفسنا في مكانك",
          "يساعدك علىتوصيل النقاط",
          "يراعي الشراكة",
          "كل شيء.",
        ],
      };

      function typeWriter(text, i, fnCallback) {
        if (i < text.length) {
          document.querySelector("#aboutTypewriter").innerHTML =
            text.substring(0, i + 1) + '<span aria-hidden="true"></span>';

          setTimeout(function () {
            typeWriter(text, i + 1, fnCallback);
          }, 50);
        } else if (typeof fnCallback == "function") {
          setTimeout(fnCallback, 1000);
        }
      }

      function StartTextAnimation(i, l) {
        /* if (typeof dataText[i] == "undefined") {
          setTimeout(function () {
            StartTextAnimation(0);
          }, 20000);
        } */
        if (typeof dataText[l][i] != "undefined" && i < dataText[l][i].length) {
          typeWriter(dataText[l][i], 0, function () {
            StartTextAnimation(i + 1, l);
          });
        }
      }

      if (document.querySelector("#aboutTypewriter") !== null) {
        var language = document
          .querySelector("#aboutTypewriter")
          .getAttribute("data-language");

        StartTextAnimation(0, language);
      }
    },
  };

  /**
   * About Explore Drop Down
   */
  Drupal.behaviors.aboutExplore = {
    attach: function (context) {
      if (document.querySelector(".about-gradient-button") !== null) {
        document
          .querySelector(".about-gradient-button")
          .addEventListener("click", function (e) {
            e.preventDefault();

            var button = e.target.classList.contains("x-text-nowrap")
              ? e.target.parentNode
              : e.target;
            var menu = document.querySelector(
              "ul#" + button.getAttribute("aria-controls")
            );

            button.setAttribute(
              "aria-expanded",
              button.getAttribute("aria-expanded") === "true" ? "false" : "true"
            );
            menu.style.height =
              button.getAttribute("aria-expanded") === "false"
                ? "0px"
                : menu.scrollHeight + "px";
          });
      }
    },
  };

  /**
   * postMessage Listener
   */
  Drupal.behaviors.postMessageListener = {
    attach: function (context) {
      window.addEventListener("message", function (e) {
        try {
          if (
            e.origin !== "https://forms.anthology.com" ||
            e.origin !== "https://learn.anthology.com"
          )
            return;

          var data = e.data;
          if (data && typeof data === "string") {
            if (data.indexOf("iframe_") !== -1) {
              _sz.push(["event", "Form", "Submission", data]);
            }
          }
        } catch (e) {}
      });
    },
  };

  /**
   * Antologia LAC Sliders
   */
  Drupal.behaviors.antologiaQuoteSlider = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".antologia-quote-slider");

        $slider.slick({
          adaptiveHeight: false,
          arrows: false,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          focusOnSelect: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          appendDots: $(".antologia-quote-slider-dots"),
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      });
    },
  };

  /**
   * Academy Form Submission Tracking
   */
  Drupal.behaviors.academySubmitTracking = {
    attach: function (context, settings) {
      var academyModal;
      function modalSubmit() {
        if (!academyModal) {
          academyModal = true;
          _sz.push([
            "event",
            "Form",
            "Submission",
            "Anthology Academy Info Request",
          ]);
        }
      }
      if (document.querySelector("#academy-submission") !== null) {
        modalSubmit();
      }
    },
  };

  /**
   * New Homepage Slider
   */
  Drupal.behaviors.newHomepageSlider = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".hp-slide");
        var $hidden = $(this).find(".hide-initially");

        $slider.slick({
          adaptiveHeight: true,
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 5000,
          focusOnSelect: true,
          slidesToShow: 1,
          prevArrow: $(".slick-prev"),
          nextArrow: $(".slick-next"),
        });
        $hidden.css("display", "block");
      });
    },
  };

  /**
   * Quote Slider on AT23 Wrap Page Quotes
   */
  Drupal.behaviors.wrapQuotes = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".wrap-quotes");

        $slider.slick({
          adaptiveHeight: true,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 5000,
          focusOnSelect: true,
          slidesToShow: 1,
        });
      });
    },
  };

  Drupal.behaviors.bioTrigger = {
    attach: function (context) {
      function getQueryVariable(query, variable) {
        if (query.indexOf("?") !== -1) {
          query = query.substring(query.indexOf("?") + 1, query.length);
        }
        if (query.indexOf("#") !== -1) {
          query = query.substring(0, query.indexOf("#"));
        }
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] === variable) {
            return pair[1];
          }
        }
        return false;
      }

      var bio = getQueryVariable(window.location.href, "bio");
      if (bio && bio !== null) {
        if (document.querySelector('[data-bio="' + bio + '"]') !== null) {
          document.querySelector('[data-bio="' + bio + '"]').click();
        }
      }
    },
  };

  // Antologia Homepage Vertical Slider + Sticky Menu
  Drupal.behaviors.antologiaHomepage = {
    attach: function (context, settings) {
      // Only run on pages with .antologia-home
      var antologiaHome = $(context).find(".antologia-home");
      if (antologiaHome.length > 0) {
        var slides = antologiaHome.find(".antologia-home-slide");
        var currentIndex = 0;

        // Slider Javascript
        function updateSlide() {
          if (currentIndex >= slides.length) {
            currentIndex = 0;
          }
          antologiaHome
            .find(".antologia-home-slider")
            .css("transform", "translateY(-" + currentIndex * 100 + "vh)");
          currentIndex++;
        }

        updateSlide();
        setInterval(updateSlide, 4000);
      }
    },
  };

  /**
   * Ultra Microsite Quote Slider
   */
  Drupal.behaviors.xSlider2 = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".x-slider-2");

        $slider.slick({
          adaptiveHeight: true,
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 5000,
          focusOnSelect: true,
          slidesToShow: 2,
          prevArrow: $(".slick-prev"),
          nextArrow: $(".slick-next"),
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      });
    },
  };

  /**
   * Resource Slider (used on AI Design Page)
   */
  Drupal.behaviors.resourceSlider = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".x-resource-slider");

        $slider.slick({
          adaptiveHeight: false,
          arrows: true,
          dots: false,
          autoplay: false,
          infinite: false,
          slidesToShow: 3,
          prevArrow: $(".slick-prev"),
          nextArrow: $(".slick-next"),
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      });
    },
  };

  /**
   * Learn Ultra Resource Slider (What's New Page)
   */
  Drupal.behaviors.learnUltraSlider = {
    attach: function (context) {
      $(document).ready(function () {
        var $slider = $(this).find(".learn-ultra-slider");

        $slider.slick({
          adaptiveHeight: false,
          arrows: true,
          dots: false,
          autoplay: false,
          infinite: false,
          slidesToShow: 3,
          prevArrow: $(".slick-prev"),
          nextArrow: $(".slick-next"),
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      });
    },
  };

  /**
   * More to Learn PF Link Switch
   */
  Drupal.behaviors.moreToLearnPfLinkSwitch = {
    attach: function (context) {
      function getQueryVariable(query, variable) {
        if (query.indexOf("?") !== -1) {
          query = query.substring(query.indexOf("?") + 1, query.length);
        }
        if (query.indexOf("#") !== -1) {
          query = query.substring(0, query.indexOf("#"));
        }
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] === variable) {
            return pair[1];
          }
        }
        return false;
      }

      if (document.querySelector(".more-to-learn-pf") !== null) {
        var linkMap = [
          "https://www.anthology.com/discover/c/ai-academic-integrity?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE",
          "https://www.anthology.com/discover/c/the-importance-of-empowering-instructors?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE",
          "https://www.anthology.com/discover/c/anthology-greenville-improves-student-success?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE",
          "https://www.anthology.com/discover/c/theres-more-to-learn?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE",
          "https://www.anthology.com/discover/c/about-blackboard-learn?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE",
          "https://www.anthology.com/discover/c/addressing-students-needs?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE",
          "https://www.anthology.com/discover/c/the-ongoing-evolution-of-lms?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE",
        ];

        var track = getQueryVariable(window.location.href, "track");
        var trackLink =
          "https://www.anthology.com/discover/c/anthology-greenville-improves-student-success?x=237_BI&lb-mode=overlay&cid=7015Y000003fTm6QAE";

        if (track !== false && isNaN(track) === false) {
          if (track >= 0 && track <= 6) {
            trackLink = linkMap[track];
          }
        }

        document.querySelector(".more-to-learn-pf").href = trackLink;

        setTimeout(function () {
          if (track !== false && isNaN(track) === false) {
            if (track >= 0 && track <= 6) {
              document.querySelector(".more-to-learn-pf").click();
            }
          }
        }, 500);
      }
    },
  };

  // Hamburger menu (used on Antologia) icon swapping on click
  Drupal.behaviors.hamburgerMenu = {
    attach: function (context) {
      if (document.querySelector(".hamburger-icon") !== null) {
        document
          .querySelector(".hamburger-icon")
          .addEventListener("click", function () {
            var hamburger = document.querySelector(".hamburger-icon");
            if (hamburger.classList.contains("fa-bars")) {
              hamburger.classList.remove("fa-bars");
              hamburger.classList.add("fa-times");
            } else {
              hamburger.classList.remove("fa-times");
              hamburger.classList.add("fa-bars");
            }
          });
      }
    },
  };

  /**
   * Learn Ultra Microsite Form Submission Tracking
   */
  Drupal.behaviors.learUltraMicrositeSubmitTracking = {
    attach: function (context, settings) {
      var learnUltraModal;
      function modalSubmit() {
        if (!learnUltraModal) {
          learnUltraModal = true;
          _sz.push([
            "event",
            "Form",
            "Submission",
            "Ultra Microsite Info Request",
          ]);
        }
      }
      if (document.querySelector("#learn-ultra-submission") !== null) {
        modalSubmit();
      }
    },
  };

  /**
   * Trigger the OneTrust Privacy Center
   */
  Drupal.behaviors.otPrivacyCenter = {
    attach: function (context) {
      if (document.querySelector(".ot-preference-center") !== null) {
        document
          .querySelector(".ot-preference-center")
          .addEventListener("click", function (e) {
            e.preventDefault();

            if (
              document
                .querySelector("#onetrust-pc-sdk")
                .classList.contains("ot-hide")
            ) {
              document
                .querySelector("#onetrust-pc-sdk")
                .classList.remove("ot-hide");
            } else {
              document
                .querySelector("#onetrust-pc-sdk")
                .classList.remove("ot-slide-out-left");
            }

            document
              .querySelector("#onetrust-pc-sdk")
              .classList.add("ot-animated");
            document
              .querySelector("#onetrust-pc-sdk")
              .classList.add("ot-slide-in-left");
            document.querySelector("#onetrust-pc-sdk").style.cssText = "";
          });
      }
    },
  };

  /**
   * Anthology Student Migration Filters
   */
  Drupal.behaviors.studentMigrationFilters = {
    attach: function (context) {
      if (document.querySelector(".student-migration-container") !== null) {
        document
          .querySelector(".filter-reset")
          .addEventListener("click", function (ev) {
            ev.preventDefault();
            document
              .querySelector(".filter-reset-container")
              .classList.add("x-display-none");
            document.querySelector(
              'select[name="interaction"]'
            ).selectedIndex = 0;
            document
              .querySelectorAll(".partner-resource-row")
              .forEach((resource) => {
                resource.classList.remove("x-display-none");
              });
          });
        document
          .querySelector('select[name="interaction"]')
          .addEventListener("change", function (ev) {
            document
              .querySelector(".filter-reset-container")
              .classList.remove("x-display-none");
            document
              .querySelectorAll(".partner-resource-row")
              .forEach((resource) => {
                resource.classList.remove("x-display-none");

                if (
                  resource
                    .getAttribute("data-interaction")
                    .indexOf(this.value) === -1
                ) {
                  resource.classList.add("x-display-none");
                }
              });
          });
      }
    },
  };

  /**
   * Roadshow Filter Functionality
   */
  Drupal.behaviors.roadshowFilter = {
    attach: function (context, settings) {
      var filterButtons = context.querySelectorAll(".roadshow-filter-button");
      var items = context.querySelectorAll(".roadshow-filter-item");

      function handleFilterClick(event) {
        var filter = this.getAttribute("data-filter");

        // Remove active class from all buttons
        for (var i = 0; i < filterButtons.length; i++) {
          filterButtons[i].classList.remove("active");
        }
        // Add active class to clicked button
        this.classList.add("active");

        for (var j = 0; j < items.length; j++) {
          if (
            filter === "all" ||
            items[j].getAttribute("data-category") === filter
          ) {
            items[j].style.display = "inline-block";
          } else {
            items[j].style.display = "none";
          }
        }
      }

      for (var k = 0; k < filterButtons.length; k++) {
        filterButtons[k].addEventListener("click", handleFilterClick);
      }
    },
  };

  /**
   * Roadshow Expandable Content Functionality
   */
  Drupal.behaviors.roadshowExpandableContent = {
    attach: function (context, settings) {
      var expandButton = context.querySelector(".roadshow-expand-button");
      var expandableContent = context.querySelector(
        ".roadshow-expandable-content"
      );
      var chevronIcon = expandButton.querySelector("i");

      function toggleExpandableContent() {
        if (
          expandableContent.style.height === "0px" ||
          expandableContent.style.height === ""
        ) {
          expandableContent.style.height =
            expandableContent.scrollHeight + "px";
          expandButton.textContent = "Less ";
          chevronIcon.classList.remove("fa-chevron-down");
          chevronIcon.classList.add("fa-chevron-up");
        } else {
          expandableContent.style.height = "0px";
          expandButton.textContent = "More ";
          chevronIcon.classList.remove("fa-chevron-up");
          chevronIcon.classList.add("fa-chevron-down");
        }
        expandButton.appendChild(chevronIcon);
      }

      if (expandButton) {
        expandButton.addEventListener("click", toggleExpandableContent);
      }
    },
  };

  /**
   * Fading Image Carousel (used in Lights, Camera, Ethical AI in Action! Blog)
   */
  Drupal.behaviors.imageCarousel = {
    attach: function (context, settings) {
      var slides = context.querySelectorAll(".fading-carousel-slide");
      var currentSlide = 0;
      var autoplayInterval;
      var autoplayEnabled = true;
      var container = context.querySelector(".fading-carousel-container");
      var isTransitioning = false;
      // Add counter element
      var counter = context.querySelector(".fading-carousel-counter");
      var totalSlides = slides.length;

      function showSlide(index) {
        if (isTransitioning) return;
        isTransitioning = true;

        var newIndex = (index + slides.length) % slides.length;
        var oldSlide = slides[currentSlide];
        var newSlide = slides[newIndex];

        // Remove any previous classes
        for (var i = 0; i < slides.length; i++) {
          slides[i].classList.remove("active", "previous");
        }

        // Set up the new slide
        newSlide.classList.add("active");
        oldSlide.classList.add("previous");

        // Update current slide index
        currentSlide = newIndex;

        // Update counter
        if (counter) {
          counter.textContent = currentSlide + 1 + "/" + totalSlides;
        }

        // Reset transition flag after animation completes
        setTimeout(function () {
          isTransitioning = false;
          oldSlide.classList.remove("previous");
        }, 1000); // Match this to your CSS transition duration
      }

      function nextSlide() {
        showSlide(currentSlide + 1);
      }

      function prevSlide() {
        showSlide(currentSlide - 1);
      }

      function startAutoplay() {
        if (autoplayEnabled) {
          autoplayInterval = setInterval(function () {
            nextSlide();
          }, 4000);
        }
      }

      function stopAutoplay() {
        clearInterval(autoplayInterval);
      }

      // Attach click handlers to control buttons
      var controlButtons = context.querySelectorAll(
        ".fading-carousel-control-btn"
      );
      for (var i = 0; i < controlButtons.length; i++) {
        controlButtons[i].addEventListener("click", function () {
          autoplayEnabled = false;
          stopAutoplay();
        });
      }

      // Handle prev/next button clicks
      var prevButton = context.querySelector(
        ".fading-carousel-control-btn:first-child"
      );
      var nextButton = context.querySelector(
        ".fading-carousel-control-btn:last-child"
      );

      if (prevButton) {
        prevButton.addEventListener("click", function (e) {
          e.preventDefault();
          prevSlide();
        });
      }

      if (nextButton) {
        nextButton.addEventListener("click", function (e) {
          e.preventDefault();
          nextSlide();
        });
      }

      // Handle hover events
      if (container) {
        container.addEventListener("mouseenter", function () {
          stopAutoplay();
        });

        container.addEventListener("mouseleave", function () {
          if (autoplayEnabled) {
            startAutoplay();
          }
        });

        // Start autoplay initially
        startAutoplay();
      }

      // Initialize counter on load
      if (counter) {
        counter.textContent = "1/" + totalSlides;
      }
    },
  };

  /**
   * Project Puppy Landing Page 6sense Personalization
   */
  Drupal.behaviors.pageHeaderPersonalization = {
    attach: function (context) {
      const pagesToPersonalize = [".page-blackboard-vs-moodle"];
      const personalizedText = {
        ".page-blackboard-vs-moodle": {
          Target: `Is Moodle's FREE price tag a mirage?`,
          Awareness: `Is Moodle's FREE price tag a mirage?`,
          Consideration: `The true price of open-source Moodle`,
          Decision: `Why institutions are making the move from Moodle to Blackboard<span class="x-superscript">®</span>`,
          Purchase: `Why institutions are making the move from Moodle to Blackboard<span class="x-superscript">®</span>`,
        },
      };
      var personalizedPage;

      pagesToPersonalize.forEach((el) => {
        if (document.querySelector(el) !== null) {
          personalizedPage = el;
        }
      });

      var settings = drupalSettings.six_sense;

      /**
       * Polls a function until it returns a resolved promise or timeout is reached
       * @param {Function} fn - Function that returns a promise to check
       * @param {Object} options - Configuration options
       * @param {number} options.interval - Polling interval in milliseconds (default: 1000)
       * @param {number} options.timeout - Maximum time to poll in milliseconds (default: 30000)
       * @param {boolean} options.stopOnError - Whether to stop polling on error (default: false)
       * @returns {Promise} - Resolves with the result of the function or rejects with timeout error
       */
      function poll(fn, options = {}) {
        const {
          interval = 1000,
          timeout = 30000,
          stopOnError = false,
        } = options;

        const startTime = Date.now();

        return new Promise((resolve, reject) => {
          const checkFn = async () => {
            // Check if timeout has been reached
            if (Date.now() - startTime > timeout) {
              return reject(new Error(`Polling timed out after ${timeout}ms`));
            }

            try {
              // Attempt to execute and resolve the provided function
              const result = await fn();
              resolve(result);
            } catch (error) {
              // If configured to stop on error, reject with the error
              if (stopOnError) {
                reject(error);
              } else {
                // Schedule next check
                setTimeout(checkFn, interval);
              }
            }
          };

          // Start polling
          checkFn();
        });
      }

      // Make the call to the 6sense API to get the data
      function personalizationGetter(cookieName) {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.addEventListener("readystatechange", function () {
          if (this.readyState === 4) {
            Cookies.set(cookieName, this.responseText, {
              domain: window.location.host,
              secure: true,
            });

            personalizeThePage(cookieName);
          }
        });

        xhr.open("GET", "https://epsilon.6sense.com/v3/company/details");
        xhr.setRequestHeader("Authorization", "Token " + settings);
        xhr.send();
      }

      // Personalize the page
      function personalizeThePage(cookieName) {
        var cookie = JSON.parse(Cookies.get(cookieName));
        var cookieNameFormatted = "." + cookieName;
        var buying_stage =
          cookie["scores"]["buying_stage"] !== undefined
            ? cookie["scores"]["buying_stage"]
            : "Decision";
        if (document.querySelector("h1[data-personalize]") !== false) {
          document.querySelector("h1[data-personalize]").innerHTML =
            personalizedText[cookieNameFormatted][buying_stage];
        }
      }

      // Check to see if the personalization cookie is set and set it if not
      function pageCookieSetter(cookieName) {
        var pageCookie = Cookies.get(cookieName);
        // If the cookie is not set make the API call and set the cookie
        if (!pageCookie) {
          personalizationGetter(cookieName);
        } else {
          personalizeThePage(cookieName);
        }
      }

      if (document.querySelector(personalizedPage) !== null) {
        // Check to see if cookies are allowed through OneTrust
        poll(async () => {
          var oneTrustCookie = Cookies.get("OptanonConsent");
          if (oneTrustCookie && oneTrustCookie.includes("C0004")) {
            pageCookieSetter(personalizedPage.replace(".", ""));
          } else {
            throw new Error("Cookies not allowed");
          }
        })
          .then((result) => {})
          .catch((error) => {});
      }
    },
  };

  /**
   * AI Design Tabs Functionality
   */
  Drupal.behaviors.aiDesignTabs = {
    attach: function (context, settings) {
      // Only run if the aidesign-feature-block exists on the page
      if (
        context !== document ||
        !document.querySelector(".aidesign-feature-block")
      )
        return;

      // Object to store the active animation number for each parent tab
      var activeAnimationState = {
        "ai-conversation-content": 1,
        "ai-design-content": 1,
      };

      // Get all tab buttons and content elements
      var tabButtons = document.querySelectorAll(".aidesign-tab-button");
      var tabContents = document.querySelectorAll(".aidesign-tab-content");

      // Function to check if an element is in viewport
      function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        return (
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.bottom >= 0 &&
          rect.left <=
            (window.innerWidth || document.documentElement.clientWidth) &&
          rect.right >= 0
        );
      }

      // Function to load iframe content when it's in viewport
      function loadIframeContent(iframe) {
        if (!iframe.src && iframe.dataset.src) {
          // Show the loader for this iframe
          var container = iframe.closest(".iframe-container");
          if (container) {
            var loader = container.querySelector(".iframe-loader");
            if (loader) {
              loader.style.display = "block";
            }
          }

          // Add load event listener to hide loader when iframe is loaded
          iframe.addEventListener("load", function () {
            if (container && loader) {
              loader.style.display = "none";
            }
          });

          // Set the src to load the iframe
          iframe.src = iframe.dataset.src;
        }
      }

      // Function to load all iframes in a tab
      function loadAllIframesInTab(tabContent) {
        if (!tabContent) return;

        var iframes = tabContent.querySelectorAll("iframe[data-src]");
        iframes.forEach(function (iframe) {
          loadIframeContent(iframe);
        });
      }

      // Function to check and load iframes for the active tab
      function checkAndLoadVisibleIframes() {
        var aiDesignBlock = document.querySelector(".aidesign-feature-block");
        if (isInViewport(aiDesignBlock)) {
          // Load all iframes in the active tab content
          var activeTabContent = document.querySelector(
            ".aidesign-tab-content.active"
          );
          if (activeTabContent) {
            loadAllIframesInTab(activeTabContent);
          }
        }
      }

      // Function to switch animations within a tab
      function switchAnimation(tabContent, animationNumber) {
        if (!tabContent) return;

        // Store the active animation for this tab
        activeAnimationState[tabContent.id] = animationNumber;

        // Update desktop animation
        // Reset all animation buttons and contents
        var animButtons = tabContent.querySelectorAll(
          ".aidesign-animation-tab-button"
        );
        for (var i = 0; i < animButtons.length; i++) {
          animButtons[i].classList.remove("active");
        }

        var animContents = tabContent.querySelectorAll(
          ".aidesign-animation-content"
        );
        for (var j = 0; j < animContents.length; j++) {
          animContents[j].classList.remove("active");
        }

        // Activate the matching button and content
        var targetButton = tabContent.querySelector(
          ".aidesign-animation-tab-button[data-animation='" +
            animationNumber +
            "']"
        );
        var targetContent = tabContent.querySelector(
          ".aidesign-animation-content[data-animation='" +
            animationNumber +
            "']"
        );

        if (targetButton) targetButton.classList.add("active");
        if (targetContent) {
          targetContent.classList.add("active");
        }

        // Update mobile animation - REMOVED
        // Reset all mobile slides - REMOVED
        // Activate the matching mobile slide - REMOVED
        // Update the mobile navigation description text - REMOVED
      }

      // Feature tab button click event
      for (var i = 0; i < tabButtons.length; i++) {
        tabButtons[i].addEventListener("click", function () {
          // Remove active class from all buttons and contents
          for (var j = 0; j < tabButtons.length; j++) {
            tabButtons[j].classList.remove("active");
          }

          for (var k = 0; k < tabContents.length; k++) {
            tabContents[k].classList.remove("active");
          }

          // Add active class to clicked button
          this.classList.add("active");

          // Get the tab to activate and find the corresponding content
          var tabToActivate = this.getAttribute("data-tab");
          var targetContent = document.getElementById(
            "ai-" + tabToActivate + "-content"
          );

          // If the content exists, add the active class
          if (targetContent) {
            targetContent.classList.add("active");

            // Get the animation number that was last active for this tab
            var activeAnimNumber = activeAnimationState[targetContent.id];

            // Switch to that animation
            switchAnimation(targetContent, activeAnimNumber);

            // If the feature block is in viewport, load all iframes in this tab
            if (
              isInViewport(document.querySelector(".aidesign-feature-block"))
            ) {
              loadAllIframesInTab(targetContent);
            }
          }
        });
      }

      // Animation tab button click event
      var animationButtons = document.querySelectorAll(
        ".aidesign-animation-tab-button"
      );
      for (var i = 0; i < animationButtons.length; i++) {
        animationButtons[i].addEventListener("click", function () {
          var parentTab = this.closest(".aidesign-tab-content");
          var animNumber = this.getAttribute("data-animation");

          switchAnimation(parentTab, animNumber);
        });
      }

      // Initialize on first load
      tabContents.forEach(function (tabContent) {
        if (tabContent.classList.contains("active")) {
          // Ensure the initial animation state is set correctly for the initially active tab
          var initialAnimation = activeAnimationState[tabContent.id] || 1;
          switchAnimation(tabContent, initialAnimation);
        }
      });

      // Add scroll event listener to check for visibility
      window.addEventListener("scroll", checkAndLoadVisibleIframes);

      // Check on initial load
      checkAndLoadVisibleIframes();

      // Also check when the window is resized
      window.addEventListener("resize", checkAndLoadVisibleIframes);

      // Initialize all loaders to be hidden initially for iframes that already have src attributes
      document
        .querySelectorAll(".iframe-container iframe[src]")
        .forEach(function (iframe) {
          var loader = iframe.parentNode.querySelector(".iframe-loader");
          if (loader) {
            loader.style.display = "none";
          }
        });
    },
  };

  /**
   * Stop modal videos/iframes when the modal closes. (specifically for Student Product Tour Page)
   */
  Drupal.behaviors.stopModalVideos = {
    attach: function (context, settings) {
      // find every modal‐toggle checkbox; if none, do nothing
      var toggles = context.querySelectorAll(".spt-modal-toggle");
      if (toggles.length === 0) {
        return;
      }

      for (var i = 0; i < toggles.length; i++) {
        (function (toggle) {
          // the markup is: <input.spt-modal-toggle> → <label.y-backdrop> → <div.y-dialog>
          var backdrop = toggle.nextElementSibling;
          if (!backdrop || !backdrop.classList.contains("y-backdrop")) {
            return;
          }
          var dialog = backdrop.nextElementSibling;
          if (!dialog || !dialog.classList.contains("y-dialog")) {
            return;
          }

          // look for either an <iframe> or an HTML5 <video> inside the dialog
          var iframe = dialog.querySelector("iframe");
          var video = dialog.querySelector("video");

          // on first pass, stash the original src into a data‑attribute
          if (iframe && !iframe.hasAttribute("data-src")) {
            iframe.setAttribute("data-src", iframe.src);
          }
          if (video && !video.hasAttribute("data-autosrc")) {
            video.setAttribute("data-autosrc", video.src);
          }

          // when the checkbox toggles…
          toggle.addEventListener("change", function () {
            if (toggle.checked) {
              // → opening: restore the src so it will load/play
              if (iframe && iframe.getAttribute("data-src")) {
                iframe.src = iframe.getAttribute("data-src");
              }
              if (video && video.getAttribute("data-autosrc")) {
                video.src = video.getAttribute("data-autosrc");
                video.play();
              }
            } else {
              // → closing: stop playback by clearing src or pausing
              if (iframe) {
                iframe.src = "";
              }
              if (video) {
                video.pause();
                video.currentTime = 0;
              }
            }
          });
        })(toggles[i]);
      }
    },
  };
})(jQuery, Drupal, drupalSettings, window.Cookies, once);
